import { useQuery } from '@tanstack/react-query'
import { keys } from '@/api/hooks/shared/keys'
import { loadLoginFromBlockedIps } from './loginFromBlockedIpData'
import type { LoginFromBlockedIpQuery } from './loginFromBlockedIpTypes'

/** Login From Blocked IP — hierarchy `getLoginFromBlockedIps`. */
export function useLoginFromBlockedIps(query: LoginFromBlockedIpQuery) {
  return useQuery({
    queryKey: keys.loginFromBlockedIps(query),
    queryFn: () => loadLoginFromBlockedIps(query),
    placeholderData: (previous) => previous,
    retry: false,
  })
}
